import axios from 'axios';
import {CUSTOMER_URI} from '../api/apiVersionConstants';

export default {
    async getCustomerInfo(customerId) {
        return axios.get(`${CUSTOMER_URI}/${customerId}`);
    }
};